import { MODULE_BASE_URL } from '../constants/ai-apps';
import { userHasAccessToApps } from '../utils/applications';
import { useMenuStore } from 'vince-core/stores/menuStore';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { VinceApp } from 'vince-core/composables/usePermission';
import { ResourceType } from 'vince-core/types/common';
import { Action } from 'vince-core/types/roles';

export default defineNuxtPlugin(() => {
    const menuStore = useMenuStore();

    menuStore.addMenuItem('ai-apps.menu', MODULE_BASE_URL, 2, Menu.MAIN, undefined, 'pi pi-ai-apps',
        () => { return userHasAccessToApps(); });

    menuStore.addMenuItem('ai-apps.tenantPromptMenu', '/tenant-prompt', 4, Menu.ADMINISTRATION, SubHeader.AI_APPS, undefined, {
        app: VinceApp.AI_APPS,
        resource: ResourceType.APP,
        resourceId: '*',
        action: Action.WRITE
    });

    menuStore.addMenuItem('ai-apps.mcpServersMenu', '/mcp-servers', 5, Menu.ADMINISTRATION, SubHeader.AI_APPS, undefined, {
        app: VinceApp.AI_APPS,
        resource: ResourceType.APP,
        resourceId: '*',
        action: Action.WRITE
    });

    useAppsRefreshMenu();
});
